export default class FormDropdown {
    private mainInput: HTMLInputElement;
    private mainInputId: string;
    private dropdownButton: HTMLElement;
    private dropdownLabel: string;
    constructor(mainInputId: string, dropdownLabel: string) {
        this.mainInputId = mainInputId;
        this.mainInput = document.getElementById(mainInputId) as HTMLInputElement;
        this.dropdownButton = document.getElementById(`${mainInputId}_Dropdown`);
        this.dropdownLabel = dropdownLabel;
        this.InitDropdown();
    }

    InitDropdown() {
        const dropdownParent = this.dropdownButton.parentElement;
        const dropdownButtonTextElement = this.dropdownButton.querySelector<HTMLElement>(".button-text");
        const formLabel = dropdownParent.parentElement.previousElementSibling;
        const labelId = this.mainInputId + "_Label";

        formLabel.setAttribute('id', labelId);
        dropdownButtonTextElement.innerHTML = this.mainInput.hasAttribute('data-displayname') ? this.mainInput.getAttribute('data-displayname') : this.dropdownLabel;

        if (!dropdownParent) return;

        const dropdownOptions = Array.from(dropdownParent.querySelectorAll<HTMLButtonElement>("li button"));
        this.dropdownButton.setAttribute('aria-labelledby', labelId);

        if (Array.isArray(dropdownOptions) && dropdownOptions.length > 0) {
            for (let i = 0; i < dropdownOptions.length; i++) {
                dropdownOptions[i].addEventListener("click", (e) => {
                    if (dropdownOptions[i] !== document.activeElement) return
                    e.preventDefault();
                    if (this.mainInput && dropdownButtonTextElement) {
                        this.selectOption(dropdownOptions[i], dropdownButtonTextElement)
                    }
                });
            }
        }
    }

    selectOption(dropdown: HTMLButtonElement, dropdownButtonTextElement: HTMLElement) {
        this.mainInput.value = dropdown.getAttribute("data-value");
        this.mainInput.setAttribute('data-displayname', dropdown.textContent);
        this.mainInput.dispatchEvent(new Event('change'));
        dropdown.parentElement?.toggleAttribute("aria-selected", dropdown !== document.activeElement)
        dropdownButtonTextElement.textContent = dropdown.textContent;
        this.dropdownButton.focus();
    }
}
